interface PasswordStrength {
  score: number; // 0-4
  label: 'very-weak' | 'weak' | 'fair' | 'strong' | 'very-strong';
  suggestions: string[];
}

export function calculateStrength(password: string): PasswordStrength {
  let score = 0;
  const suggestions: string[] = [];

  // Length check
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (password.length >= 16) score++;

  // Character variety
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSymbol = /[^a-zA-Z0-9]/.test(password);

  const varietyCount = [hasLower, hasUpper, hasNumber, hasSymbol].filter(
    Boolean
  ).length;

  if (varietyCount >= 3) score++;
  if (varietyCount === 4) score++;

  // Common patterns (reduce score)
  const commonPatterns = [
    /^123/,
    /password/i,
    /qwerty/i,
    /abc123/i,
    /(.)\1{2,}/, // repeated characters
  ];

  for (const pattern of commonPatterns) {
    if (pattern.test(password)) {
      score = Math.max(0, score - 1);
    }
  }

  // Suggestions
  if (password.length < 12) {
    suggestions.push('Use pelo menos 12 caracteres');
  }
  if (!hasLower) {
    suggestions.push('Adicione letras minusculas');
  }
  if (!hasUpper) {
    suggestions.push('Adicione letras maiusculas');
  }
  if (!hasNumber) {
    suggestions.push('Adicione numeros');
  }
  if (!hasSymbol) {
    suggestions.push('Adicione simbolos especiais');
  }

  // Normalize score to 0-4
  score = Math.min(4, Math.max(0, score));

  const labels: PasswordStrength['label'][] = [
    'very-weak',
    'weak',
    'fair',
    'strong',
    'very-strong',
  ];

  return {
    score,
    label: labels[score],
    suggestions,
  };
}
